import { hasAnalyticsConsent, hasConsentBeenGiven } from '../utils/cookieConsent'

export const GA4_CONFIG = {
  MEASUREMENT_ID: 'G-NRGQ5QWB4Q',
  SETTINGS: {
    ENABLE_IN_DEV: false,
    DEBUG_MODE: process.env.NODE_ENV === 'development',
    ENHANCED_ECOMMERCE: {
      CURRENCY: 'USD',
    }
  }
}

export const isAnalyticsEnabled = () => {
  if (typeof window === 'undefined') return false

  if (process.env.NODE_ENV === 'development' && !GA4_CONFIG.SETTINGS.ENABLE_IN_DEV) {
    return false
  }

  if (!hasConsentBeenGiven() || !hasAnalyticsConsent()) {
    return false
  }

  return true
}

let gaInitialized = false

export const initializeGA4 = () => {
  if (!isAnalyticsEnabled()) return
  if (gaInitialized) return

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_CONFIG.MEASUREMENT_ID}`
  script.id = 'ga4-gtag-script'
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag = function () {
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', GA4_CONFIG.MEASUREMENT_ID, {
    send_page_view: false,
    debug_mode: GA4_CONFIG.SETTINGS.DEBUG_MODE,
  })

  gaInitialized = true
}

export const removeGA4 = () => {
  const script = document.getElementById('ga4-gtag-script')
  if (script) {
    script.remove()
  }

  window.dataLayer = []
  delete window.gtag

  const cookies = document.cookie.split(';')
  cookies.forEach(cookie => {
    const name = cookie.split('=')[0].trim()
    if (name.startsWith('_ga') || name.startsWith('_gid')) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
    }
  })

  gaInitialized = false
}

export const trackPageView = (path, title) => {
  if (!isAnalyticsEnabled() || !window.gtag) return

  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
  })
}

export const trackEvent = (eventName, params = {}) => {
  if (!isAnalyticsEnabled() || !window.gtag) return

  window.gtag('event', eventName, params)
}
